import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { Permissions, userHasPermission, userHasRole } from 'services/Authorization';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { Roles } from 'UI/constants/roles';

export const useCompanyProfileFeatureFlags = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canUseDailyPlanTask: userHasPermission(Permissions.DailyPlan.CanUseModule),
    isAddDailyPlanTaskEnabled: checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile),
    isCurrentUserFromDataCoordination: userHasRole(Roles.DataCoordinator)
  };
};
